export default __webpack_public_path__ + "static/media/money-hero-logo.85cc59c2.png";